import { Container as MantineContainer, type ContainerProps as MantineContainerProps } from '@mantine/core';
import { forwardRef } from 'react';

export type ContainerProps = MantineContainerProps;

export const Container = forwardRef<HTMLDivElement, ContainerProps>(function Container(props, ref) {
  return <MantineContainer ref={ref} size="xl" px={{ base: 'sm', sm: 'md' }} {...props} />;
});
